export default "__VITE_ASSET__CLuuMiMr__"